"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalMountPoint = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _visualStack = require("@cjdev-internal/visual-stack");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Backdrop = _visualStack.Modal.Backdrop;

var ModalMountPointPure = function ModalMountPointPure(_ref) {
  var Component = _ref.component,
      props = _ref.props;
  return Component ? _react.default.createElement("div", null, _react.default.createElement(Component, props), _react.default.createElement(Backdrop, null)) : _react.default.createElement("div", null);
};

var ModalMountPoint = (0, _reactRedux.connect)(function (state) {
  return {
    component: state.visualStack.modal.component,
    props: state.visualStack.modal.props
  };
})(ModalMountPointPure);
exports.ModalMountPoint = ModalMountPoint;